import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  root: {
    marginTop: 5,
  },
}))

export default styles
